"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchManifest = exports.fetchManifestUrl = exports.fetchConfig = exports.configCache = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
exports.configCache = {};
// todo type the manifest cache
const manifestCache = {};
const fetchConfig = ({ host, source, cache }) => __awaiter(void 0, void 0, void 0, function* () {
    if (cache && exports.configCache[host]) {
        console.log('server cached');
        return exports.configCache[host];
    }
    const configUrl = new URL(host + '.json', source).href;
    console.log('loading config', configUrl);
    try {
        return (exports.configCache[host] = yield (0, cross_fetch_1.default)(configUrl).then(a => a.json()));
    }
    catch (e) {
        console.log('Failed to load', configUrl);
    }
    const parts = host.split('.');
    if (parts.length > 1) {
        parts.shift();
        const config = yield (0, exports.fetchConfig)({ host: parts.join('.'), source, cache });
        if (config) {
            // cache so we don't attempt to load this subdomain again
            exports.configCache[host] = Object.assign(Object.assign({}, config), { auth: Object.assign(Object.assign({}, config.auth), { redirect_uri: `https://${host}/signin-oidc` }) });
        }
        return exports.configCache[host];
    }
    return null;
});
exports.fetchConfig = fetchConfig;
const fetchManifestUrl = (url) => __awaiter(void 0, void 0, void 0, function* () {
    if (manifestCache[url])
        return manifestCache[url];
    try {
        return yield (0, cross_fetch_1.default)(url).then((a) => a.json());
    }
    catch (e) {
        console.log('Unable to fetch manifest', e);
        return [];
    }
});
exports.fetchManifestUrl = fetchManifestUrl;
const fetchManifest = (c) => {
    const ret = { scripts: [], base: undefined };
    if (c.script) {
        ret.scripts = [c.script];
    }
    if (c.assets) {
        ret.scripts = [c.assets];
        ret.base = c.assets;
    }
    return ret;
};
exports.fetchManifest = fetchManifest;
